var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    staticClass: "mt-5",
    attrs: {
      "title": "Anexos",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab && !_vm.store.isUpdate
    },
    on: {
      "click": function click() {
        return _vm.store.currentTab = 7;
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Anexo 1",
      "label-for": "anexo1"
    }
  }, [_vm.anexo_1 ? _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('a', {
    staticClass: "rounded-0 mr-2",
    attrs: {
      "href": _vm.anexo_1,
      "target": "_blank"
    }
  }, [_vm._v("Visualizar Anexo")]), _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: 'Remover anexo',
      expression: "'Remover anexo'",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "btn btn-light-primary btn-sm btn-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.removeAnexo('anexo_1', 'anexo_1_file');
      }
    }
  }, [_c('TrashCanIcon', {
    attrs: {
      "size": 16
    }
  })], 1)]) : _vm._e(), _c('b-form-file', {
    ref: "anexo_1_file",
    attrs: {
      "accept": "image/jpeg, image/png, application/pdf, video/*"
    },
    on: {
      "change": function change(event) {
        return _vm.setAnexo(event, 'anexo_1');
      }
    },
    model: {
      value: _vm.fileInputs.anexo_1,
      callback: function callback($$v) {
        _vm.$set(_vm.fileInputs, "anexo_1", $$v);
      },
      expression: "fileInputs.anexo_1"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Anexo 2",
      "label-for": "anexo2"
    }
  }, [_vm.anexo_2 ? _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('a', {
    staticClass: "rounded-0 mr-2",
    attrs: {
      "href": _vm.anexo_2,
      "target": "_blank"
    }
  }, [_vm._v("Visualizar Anexo")]), _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: 'Remover anexo',
      expression: "'Remover anexo'",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "btn btn-light-primary btn-sm btn-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.removeAnexo('anexo_2', 'anexo_2_file');
      }
    }
  }, [_c('TrashCanIcon', {
    attrs: {
      "size": 16
    }
  })], 1)]) : _vm._e(), _c('b-form-file', {
    ref: "anexo_2_file",
    attrs: {
      "accept": "image/jpeg, image/png, application/pdf, video/*"
    },
    on: {
      "change": function change(event) {
        return _vm.setAnexo(event, 'anexo_2');
      }
    },
    model: {
      value: _vm.fileInputs.anexo_2,
      callback: function callback($$v) {
        _vm.$set(_vm.fileInputs, "anexo_2", $$v);
      },
      expression: "fileInputs.anexo_2"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Anexo 3",
      "label-for": "anexo3"
    }
  }, [_vm.anexo_3 ? _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('a', {
    staticClass: "rounded-0 mr-2",
    attrs: {
      "href": _vm.anexo_3,
      "target": "_blank"
    }
  }, [_vm._v("Visualizar Anexo")]), _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: 'Remover anexo',
      expression: "'Remover anexo'",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "btn btn-light-primary btn-sm btn-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.removeAnexo('anexo_3', 'anexo_3_file');
      }
    }
  }, [_c('TrashCanIcon', {
    attrs: {
      "size": 16
    }
  })], 1)]) : _vm._e(), _c('b-form-file', {
    ref: "anexo_3_file",
    attrs: {
      "accept": "image/jpeg, image/png, application/pdf, video/*"
    },
    on: {
      "change": function change(event) {
        return _vm.setAnexo(event, 'anexo_3');
      }
    },
    model: {
      value: _vm.fileInputs.anexo_3,
      callback: function callback($$v) {
        _vm.$set(_vm.fileInputs, "anexo_3", $$v);
      },
      expression: "fileInputs.anexo_3"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Anexo 4",
      "label-for": "anexo4"
    }
  }, [_vm.anexo_4 ? _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('a', {
    staticClass: "rounded-0 mr-2",
    attrs: {
      "href": _vm.anexo_4,
      "target": "_blank"
    }
  }, [_vm._v("Visualizar Anexo")]), _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: 'Remover anexo',
      expression: "'Remover anexo'",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "btn btn-light-primary btn-sm btn-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.removeAnexo('anexo_4', 'anexo_4_file');
      }
    }
  }, [_c('TrashCanIcon', {
    attrs: {
      "size": 16
    }
  })], 1)]) : _vm._e(), _c('b-form-file', {
    ref: "anexo_4_file",
    attrs: {
      "accept": "image/jpeg, image/png, application/pdf, video/*"
    },
    on: {
      "change": function change(event) {
        return _vm.setAnexo(event, 'anexo_4');
      }
    },
    model: {
      value: _vm.fileInputs.anexo_4,
      callback: function callback($$v) {
        _vm.$set(_vm.fileInputs, "anexo_4", $$v);
      },
      expression: "fileInputs.anexo_4"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Anexo 5",
      "label-for": "anexo5"
    }
  }, [_vm.anexo_5 ? _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('a', {
    staticClass: "rounded-0 mr-2",
    attrs: {
      "href": _vm.anexo_5,
      "target": "_blank"
    }
  }, [_vm._v("Visualizar Anexo")]), _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: 'Remover anexo',
      expression: "'Remover anexo'",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "btn btn-light-primary btn-sm btn-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.removeAnexo('anexo_5', 'anexo_5_file');
      }
    }
  }, [_c('TrashCanIcon', {
    attrs: {
      "size": 16
    }
  })], 1)]) : _vm._e(), _c('b-form-file', {
    ref: "anexo_5_file",
    attrs: {
      "accept": "image/jpeg, image/png, application/pdf, video/*"
    },
    on: {
      "change": function change(event) {
        return _vm.setAnexo(event, 'anexo_5');
      }
    },
    model: {
      value: _vm.fileInputs.anexo_5,
      callback: function callback($$v) {
        _vm.$set(_vm.fileInputs, "anexo_5", $$v);
      },
      expression: "fileInputs.anexo_5"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Anexo 6",
      "label-for": "anexo6"
    }
  }, [_vm.anexo_6 ? _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('a', {
    staticClass: "rounded-0 mr-2",
    attrs: {
      "href": _vm.anexo_6,
      "target": "_blank"
    }
  }, [_vm._v("Visualizar Anexo")]), _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: 'Remover anexo',
      expression: "'Remover anexo'",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "btn btn-light-primary btn-sm btn-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.removeAnexo('anexo_6', 'anexo_6_file');
      }
    }
  }, [_c('TrashCanIcon', {
    attrs: {
      "size": 16
    }
  })], 1)]) : _vm._e(), _c('b-form-file', {
    ref: "anexo_6_file",
    attrs: {
      "accept": "image/jpeg, image/png, application/pdf, video/*"
    },
    on: {
      "change": function change(event) {
        return _vm.setAnexo(event, 'anexo_6');
      }
    },
    model: {
      value: _vm.fileInputs.anexo_6,
      callback: function callback($$v) {
        _vm.$set(_vm.fileInputs, "anexo_6", $$v);
      },
      expression: "fileInputs.anexo_6"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };